/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Error_Age_Out_Of_Range13Inputs */

const en_us2_body_assessment_error_age_out_of_range13 = /** @type {(inputs: Body_Assessment_Error_Age_Out_Of_Range13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The photo estimate is only available from age 15.`)
};

const pt_br2_body_assessment_error_age_out_of_range13 = /** @type {(inputs: Body_Assessment_Error_Age_Out_Of_Range13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A estimativa por foto só está disponível a partir dos 15 anos.`)
};

const es_419_body_assessment_error_age_out_of_range13 = /** @type {(inputs: Body_Assessment_Error_Age_Out_Of_Range13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La estimación por foto solo está disponible a partir de los 15 años.`)
};

const pt_pt2_body_assessment_error_age_out_of_range13 = /** @type {(inputs: Body_Assessment_Error_Age_Out_Of_Range13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A estimativa por foto só está disponível a partir dos 15 anos.`)
};

const fr_fr2_body_assessment_error_age_out_of_range13 = /** @type {(inputs: Body_Assessment_Error_Age_Out_Of_Range13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'estimation par photo n'est disponible qu'à partir de 15 ans.`)
};

const de_de2_body_assessment_error_age_out_of_range13 = /** @type {(inputs: Body_Assessment_Error_Age_Out_Of_Range13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Fotoschätzung ist erst ab 15 Jahren verfügbar.`)
};

const it_it2_body_assessment_error_age_out_of_range13 = /** @type {(inputs: Body_Assessment_Error_Age_Out_Of_Range13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La stima da foto è disponibile solo dai 15 anni.`)
};

/**
* | output |
* | --- |
* | "The photo estimate is only available from age 15." |
*
* @param {Body_Assessment_Error_Age_Out_Of_Range13Inputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_error_age_out_of_range13 = /** @type {((inputs?: Body_Assessment_Error_Age_Out_Of_Range13Inputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Error_Age_Out_Of_Range13Inputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_error_age_out_of_range13(inputs)
	if (locale === "es-419") return es_419_body_assessment_error_age_out_of_range13(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_error_age_out_of_range13(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_error_age_out_of_range13(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_error_age_out_of_range13(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_error_age_out_of_range13(inputs)
	return en_us2_body_assessment_error_age_out_of_range13(inputs)
});
export { body_assessment_error_age_out_of_range13 as "body-assessment.error.AGE_OUT_OF_RANGE" }